/** Sends the request without a hosted access token. */
export const authedFetch: typeof fetch = (input, init) => fetch(input, init)
